import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, Menu, X } from 'lucide-react';

export const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="px-6 py-4 border-b border-gray-100 bg-white/95 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
            <Briefcase className="w-6 h-6 text-white" />
          </div>
          <div>
            <span className="text-xl font-bold text-gray-900">NYC Gigs</span>
            <p className="text-xs text-gray-500 -mt-1">Flexible Work Opportunities</p>
          </div>
        </Link>
        <nav className="hidden md:flex space-x-8">
          <Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">Home</Link>
          <Link to="/jobs" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">Jobs</Link>
          <a href="/#how-it-works" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">How It Works</a>
          <a href="/#testimonials" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">Success Stories</a>
        </nav>
        <div className="flex items-center space-x-4">
          <Link to="/jobs" className="hidden sm:inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">
            Browse Jobs
          </Link>
          <Link to="/jobs" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl">
            Get Started
          </Link>
          
          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white">
          <nav className="px-6 py-4 space-y-4">
            <Link 
              to="/" 
              className="block text-gray-600 hover:text-gray-900 transition-colors font-medium py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/jobs" 
              className="block text-gray-600 hover:text-gray-900 transition-colors font-medium py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Jobs
            </Link>
            <a 
              href="/#how-it-works" 
              className="block text-gray-600 hover:text-gray-900 transition-colors font-medium py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              How It Works
            </a>
            <a 
              href="/#testimonials" 
              className="block text-gray-600 hover:text-gray-900 transition-colors font-medium py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Success Stories
            </a>
            <div className="pt-4 border-t border-gray-100 space-y-3">
              <Link 
                to="/jobs" 
                className="block w-full text-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Browse Jobs
              </Link>
              <Link 
                to="/jobs" 
                className="block w-full text-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Get Started
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
